import {
  CHANGE_APPLICANT_TYPE,
  SELECT_CHILD,
  LOAD_DRAFT_EMPTY
} from '../constants';

const initialState = {
  type: null,
  child: null
};

const changeApplicantType = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_APPLICANT_TYPE:
      return {
        ...state,
        type: action.payload
      };
    case SELECT_CHILD:
      return {
        ...state,
        child: action.payload
      };
    case LOAD_DRAFT_EMPTY:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

export default changeApplicantType;
